import React from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
// Mobile detector
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const HeroSection = () => {
  return <div className="relative bg-[#1A1F47] text-white" data-id="element-157">
      <div className="absolute inset-0 overflow-hidden" data-id="element-158">
        <img src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="Luxury property in Nigeria" className="w-full h-full object-cover opacity-20" data-id="element-159" />
      </div>
      <div className="relative container mx-auto px-4 py-16 md:py-32" data-id="element-160">
        <div className="max-w-3xl" data-id="element-161">
          <h1 className={`${isMobile ? 'text-3xl' : 'text-4xl md:text-5xl lg:text-6xl'} font-bold mb-6`} data-id="element-162">
            Your Trusted Bridge to Property Ownership in Nigeria
          </h1>
          <p className="text-lg md:text-xl mb-8" data-id="element-163">
            Secure, transparent, and hassle-free real estate solutions for
            Nigerians in the diaspora.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mb-12" data-id="element-164">
            <Link to="/properties" className="px-8 py-4 bg-white text-[#1A1F47] font-bold rounded-lg hover:bg-gray-100 transition text-center" data-id="element-165">
              Browse Properties
            </Link>
            <Link to="/auth" className="px-8 py-4 bg-transparent border-2 border-white font-bold rounded-lg hover:bg-white hover:text-[#1A1F47] transition text-center" data-id="element-166">
              Sign Up Now
            </Link>
          </div>
          {/* Search form - simplified for mobile */}
          {isMobile ? <div className="bg-white rounded-lg p-4 shadow-lg" data-id="element-167">
              <div className="flex flex-col space-y-4" data-id="element-168">
                <select className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-169">
                  <option value="" data-id="element-170">Select Location</option>
                  <option data-id="element-171">Lagos</option>
                  <option data-id="element-172">Abuja</option>
                  <option data-id="element-173">Port Harcourt</option>
                  <option data-id="element-174">Ibadan</option>
                  <option data-id="element-175">Kano</option>
                </select>
                <select className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-176">
                  <option value="" data-id="element-177">Property Type</option>
                  <option data-id="element-178">Apartment</option>
                  <option data-id="element-179">House</option>
                  <option data-id="element-180">Land</option>
                  <option data-id="element-181">Commercial</option>
                </select>
                <button className="w-full bg-[#FF4E00] text-white px-6 py-3 rounded-lg hover:bg-[#e64600] transition flex items-center justify-center" data-id="element-182">
                  <SearchIcon size={20} className="mr-2" data-id="element-183" />
                  Search Properties
                </button>
              </div>
            </div> : <div className="bg-white rounded-lg p-4 shadow-lg" data-id="element-184">
              <div className="flex flex-col md:flex-row md:items-end space-y-4 md:space-y-0 md:space-x-4" data-id="element-185">
                <div className="flex-1" data-id="element-186">
                  <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-187">
                    Location
                  </label>
                  <select className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-188">
                    <option data-id="element-189">Lagos</option>
                    <option data-id="element-190">Abuja</option>
                    <option data-id="element-191">Port Harcourt</option>
                    <option data-id="element-192">Ibadan</option>
                    <option data-id="element-193">Kano</option>
                  </select>
                </div>
                <div className="flex-1" data-id="element-194">
                  <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-195">
                    Property Type
                  </label>
                  <select className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-196">
                    <option data-id="element-197">All Types</option>
                    <option data-id="element-198">Apartment</option>
                    <option data-id="element-199">House</option>
                    <option data-id="element-200">Land</option>
                    <option data-id="element-201">Commercial</option>
                  </select>
                </div>
                <div className="flex-1" data-id="element-202">
                  <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-203">
                    Price Range
                  </label>
                  <select className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-204">
                    <option data-id="element-205">Any Price</option>
                    <option data-id="element-206">₦5M - ₦20M</option>
                    <option data-id="element-207">₦20M - ₦50M</option>
                    <option data-id="element-208">₦50M - ₦100M</option>
                    <option data-id="element-209">₦100M+</option>
                  </select>
                </div>
                <button className="bg-[#FF4E00] text-white px-6 py-3 rounded-lg hover:bg-[#e64600] transition flex items-center justify-center" data-id="element-210">
                  <SearchIcon size={20} className="mr-2" data-id="element-211" />
                  Search
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default HeroSection;